export const toSafeInternalPath = (route: unknown, fallback = "/"): string => {
    if (typeof route !== "string") return fallback;
    return /^\/(?![/\\])/.test(route) ? route : fallback;
};
